import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
})
export class UserListComponent extends BaseListCtl {
  public userContext: any = {};
  public appInfo: any;
  public isInviteButtonDisabled: boolean = false;
  public isSelectDisabled = false;
  public datavalidate = true;
  public applicationRoles: any = [];
  public applicationRolesList: any = [];
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute 
  ) {
    super('', locator, route);
    locator.config
      .getProperty('endpoint.application.users')
      .then((property: string) => {
        this.initApiEndpoint(property);

        let _self = this;
        let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
        _self.userContext = JSON.parse(
          localStorage.getItem(keySuffix + 'userContext') || '{}'
        );

        _self.form.data.id = _self.userContext['userId'];

        let url = this.locator.getEndpoint('endpoint.global.USER') + '/profile';
        this.locator.http.get(url, function (res: any, error: boolean) {
          if (error) {
            alert('Server Error:' + error);
            return;
          }
          _self.form.error = !res.success;
          _self.form.message = res.message;
          _self.populateForm(_self.form.data, res.result.data);
        });
        locator.getPathVariable(route, function (params: any) {
          _self.form.searchParams['appId'] = params['appId'];
        });
      });
  }

  override search() {
    let _self = this;
    if (_self.form.searchParams['applicationId']) {
      super.search();
    } else {
      _self.resetSearchList();
    }
  }

  resetSearchList() {
    this.form.list = [];
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.email = data.email;
    form.applicationRoleId = data.applicationRoleId;
    form.applicationRoleName = data.applicationRoleName;
    form.status = data.status;
    form.userFirstname = data.userFirstname;
    form.applicationId = data.applicationId;
    form.applicationName = data.applicationName;
  }

  /**
   * Change app status
   * @param id
   * @param status
   */
  public changeStatus(id: number, status: string) {
    let _self = this;
    let url =
      this.locator.getEndpoint('endpoint.application.users') +
      '/changestatus/' +
      id +
      '/' +
      status;
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      _self.form.error = !res.success;
      _self.form.message = res.message;

      if (res.success) {
        alert('Status is changed to ' + status);
        _self.form.list.forEach((e: any) => {
          if (e.id === id) {
            e.status = res.result.data.status;
          }
        });
      } else {
        alert('Error: ' + res.message);
      }
    });
  }

  checkDuplicate(email: any, roleId: any, applicationId: any) {
    let _self = this;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Validate email format
    if (!emailPattern.test(email)) {
      console.error('Email is not valid');
      _self.form.error = true;
      _self.datavalidate = false;
      this.isSelectDisabled = false;
      _self.form.message = 'Email not valid';
      return;
    }

    // Validate roleId
    if (!roleId || roleId === 'undefined') {
      _self.datavalidate = false;
      this.isSelectDisabled = false;
      console.error('datavalidate is false: roleId is missing or invalid');
      return;
    }

    // Validate applicationId
    if (!applicationId || applicationId === 'undefined') {
      _self.datavalidate = false;
      console.error(
        'datavalidate is false: applicationId is missing or invalid'
      );
      return;
    }

    // Check for duplicate based on email, roleId, and applicationId
    let user = _self.form.list.find(
      (user: { email: any; applicationRoleId: any; applicationId: any }) =>
        user.email === email &&
        user.applicationRoleId == roleId &&
        user.applicationId == applicationId
    );

    if (user) {
      _self.datavalidate = false;
      _self.isInviteButtonDisabled=true;
      _self.form.error = true;
      _self.form.message =
        'This email is already assigned to this role in the selected application.';
      console.error('User found:', user);
    } else {
      _self.datavalidate = true;
      _self.form.error = false;
      _self.isInviteButtonDisabled=false;
      _self.form.message = '';
      console.error('User not found');
    }
  }

  /**
   * Get usecase attributes
   * @param id
   */
//  getApplicationRoles() {
//    let _self = this;
//    _self.form.data['applicationRoleId'] = null;
//    let url =
//      this.locator.getEndpoint('endpoint.application.users') +
//      '/application-roles/' +
//      _self.form.data['applicationId'];
//    this.locator.http.get(url, function (res: any, error: boolean) {
//      if (error) {
//        alert('Server Error:' + error);
//        return;
//     }
//      _self.applicationRoles = res.result.data;
//    });
 // }

 getApplicationRoles() {
    this.search();
  // Reset applicationRoleId to 'undefined' before loading the roles
    this.form.searchParams['applicationRoleId'] = undefined;
    let url =
      this.locator.getEndpoint('endpoint.application.users') +
      '/application-roles/' +
      this.form.searchParams['applicationId'];

  this.locator.http.get(url, (res: any, error: boolean) => {
    if (error) {
      alert('Server Error:' + error);
      return;
    }
    this.applicationRoles = res.result.data;
  });
  }

  getApplicationRole() {
    // Reset applicationRoleId to 'undefined' before loading the roles
    this.form.searchParams['applicationRoleId'] = undefined;
    let url =
      this.locator.getEndpoint('endpoint.application.users') +
      '/application-roles/' +
      this.form.data['applicationId'];

    this.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      this.applicationRolesList = res.result.data;
    });
}

  setApp(e: any) {
    this.appInfo = e;
  }

  formatDate(date: any): string {
    if (!date) return 'N/A';
    return new Date(date).toLocaleString();
  }

  // --------------Remove Duplicate Values from app role drop-down--------------------------------

  /**
   * Role list filter for unique values
   * @param roles
   * @returns
   */
  getUniqueRoles(roles: any[]): string[] {
  if (!roles) return []; // Handle case where roles is undefined or null

  // Use a Set to filter out duplicates (case-insensitive)
  const uniqueValues = new Set(
      roles.map((role) => role['_val'].toLowerCase()) // Normalize to lowercase
  );

  // Convert the Set back to an array and return the original values
    return Array.from(uniqueValues).map((val) => {
    // Find the first occurrence of the lowercase value in the original array
      const originalRole = roles.find(
        (role) => role['_val'].toLowerCase() === val
      );
    return originalRole['_val']; // Return the original value (not lowercase)
  });
}

  public async save1() {
    this.isInviteButtonDisabled = true;
    this.isSelectDisabled = true;
    await this.save();
    // Clear form data (reset email, roleId, applicationId, etc.)
    this.form.data['email'] = '';
    this.form.data['applicationId'] = undefined;
    this.form.data['applicationRoleId'] = undefined;
    this.applicationRoles = [];
  }

  convertStrToNumUser(searchData: any, lebal: any) {
    if (
      searchData !== null &&
      searchData !== undefined &&
      searchData !== 'undefined'
    ) {
      this.form.searchParams[lebal] = Number(searchData);
    }
  }
}
